import {
  signIn as amplifySignIn,
  signOut as amplifySignOut,
  getCurrentUser as amplifyGetCurrentUser,
  fetchAuthSession,
  resetPassword,
  confirmResetPassword,
  confirmSignIn,
  fetchUserAttributes
} from 'aws-amplify/auth';
import { CognitoUser } from './constants';

export async function getCredentials(): Promise<any> {
  const session = await fetchAuthSession();
  return session.credentials;
}

export async function signOut(): Promise<void> {
  await amplifySignOut();
  location.reload();
}

export async function getAccessToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession({ forceRefresh: true });
    return session.tokens?.idToken?.toString() ?? null;
  } catch (err) {
    console.log('Failed to refresh token', err);
    return null;
  }
}

export async function forgotPassword(username: string): Promise<void> {
  await resetPassword({ username });
}

export async function forgotPasswordSubmit(email: string, confirmationCode: string, newPassword: string): Promise<void> {
  await confirmResetPassword({ username: email, confirmationCode, newPassword });
}

export async function signIn(email: string, password: string): Promise<CognitoUser> {
  const result = await amplifySignIn({ username: email, password });
  if (result.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
    return { username: email, challengeName: 'NEW_PASSWORD_REQUIRED' } as CognitoUser;
  }
  return getCurrentUser();
}

export async function completeNewPassword(_user: Partial<CognitoUser> | undefined, password: string): Promise<CognitoUser> {
  await confirmSignIn({ challengeResponse: password });
  return getCurrentUser();
}

export async function getJwtToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.accessToken?.toString() ?? '';
}

export async function getCurrentUser(): Promise<CognitoUser> {
  const user = await amplifyGetCurrentUser();
  const attributes = await fetchUserAttributes();
  const session = await fetchAuthSession();

  const idTokenPayload = session.tokens?.idToken?.payload;

  return {
    username: user.username,
    attributes: {
      email: attributes.email ?? '',
      family_name: attributes.family_name ?? '',
      given_name: attributes.given_name ?? '',
      'custom:mandant': attributes['custom:mandant'] ?? '',
      'custom:kuerzel': attributes['custom:kuerzel'] ?? ''
    },
    signInUserSession: {
      idToken: {
        payload: {
          'custom:kuerzel': (idTokenPayload?.['custom:kuerzel'] as string) ?? '',
          'cognito:groups': (idTokenPayload?.['cognito:groups'] as string[]) ?? []
        },
        jwtToken: session.tokens?.idToken?.toString() ?? ''
      }
    },
    unverified: {
      email: ''
    }
  };
}
